"use client";

import { Menu } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, type SheetSide } from "@/components/ui/sheet";
import { Nav } from "@/components/layout/Nav";
import type { PageSummary } from "@/types/page";
import type { MenuItemDto } from "@/types/menu";

interface MobileMenuProps {
  labelVisible?: boolean;
  pages: PageSummary[];
  menuItems?: MenuItemDto[];
  position?: SheetSide;
}

export function MobileMenu({ pages, menuItems = [], position = "bottom", labelVisible = false }: MobileMenuProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="md:hidden">
      <Button
        type="button"
        variant="ghost"
        size="icon"
        aria-label="Open menu"
        data-nav-toggle="mobile"
        aria-expanded={open}
        aria-controls="mobile-menu-panel"
        onClick={(event) => { event.currentTarget.focus(); setOpen(true); }}
      >
        <Menu className="h-6 w-6" />
        {labelVisible && <span>Menu</span>}
      </Button>
      <Sheet open={open} onOpenChange={setOpen} title="Menu" side={position} mobileNavigation>
        <Nav pages={pages} menuItems={menuItems} ariaLabel="Mobile" onNavigate={() => setOpen(false)} />
      </Sheet>
    </div>
  );
}
